export default __webpack_public_path__ + "static/boat-aaeb4de33eec16dfd9f1995105418a6b.png";